
<!-- Modal content-->
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="close" (click)="dismiss()"><img src="{{Constant.icon_url_close_no_backround}}"></button>
      <div class="col-12">
        <label class="title-top">{{'register.label.upload_image' | translate}}</label>
      </div>
    </div>
    <div class="modal-body">
      <div class="row">
          <div class="col-6 col-sm-6 col-md-6">
            <div class="img-content">
              <img [hidden]="isUploadFile" id="isUploadFileImage" onError="this.src = 'https://s3-ap-southeast-1.amazonaws.com/fmarket-static/dev/assets/images/icon/upload.png'"
              src="{{defaultPhoto}}" class="fix-image">
              <input id="fileInput" #fileInput type="file" [(ngModel)]="images" class="file-upload" name="avatar" title=" "
                ng2FileSelect [uploader]="uploader1"/>  
              <uploading-icon *ngIf="isUpload1"></uploading-icon>     
            </div>
          </div>
          <div class="col-6 col-sm-6 col-md-6">
            <div class="img-content">
              <img [hidden]="isUploadFile1" id="isUploadFileImage1" onError="this.src = 'https://s3-ap-southeast-1.amazonaws.com/fmarket-static/dev/assets/images/icon/upload.png'"
              src="{{defaultPhoto1}}" class="fix-image">
              <input id="fileInput2" #fileInput2 type="file" [(ngModel)]="images1" class="file-upload" name="avatar" title=" "
                  ng2FileSelect [uploader]="uploader2"/>
              <uploading-icon *ngIf="isUpload2"></uploading-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-6 no-padding-right"><button class="btn btn--trans" type="button"
              (click)="dismiss()">{{'common.button.cancel' | translate}}</button></div>
          <div class="col-6"><button class="btn btn--green" type="button"
            [disabled]="!isChange" (click)="submit()">{{'common.button.ok' | translate}}</button></div>
        </div>
      </div>
    </div>
<!--Loading-->
<div class="modal fade upload-modal-loading" id="uploadLoadingModal" bsModal #uploadLoadingModal="bs-modal"
 [config]="{backdrop: 'static'}" role="dialog"
aria-labelledby="addBank" aria-hidden="true">
  <img src="{{Constant.icon_url_loading}}" height="50">
</div>
